import { createStyles, makeStyles, Theme } from '@material-ui/core';
import styled from 'styled-components';


export const useStyles = makeStyles<Theme>((theme: Theme) =>
   createStyles({
      buttonWrapper: {
         display: 'flex',
         justifyContent: 'center',
         margin: theme.spacing(2),
         width: 'auto',
         marginTop: 50,
         marginBottom: 73,
      },
      buttonWrapper2: {
         marginTop: 50,
      },
   })
);

export const GrayActionButton = styled.button`

  width: 20%;
  height: 70px;
  border-radius: 15px;
  border: none;
  outline: none;
  background: transparent linear-gradient(90deg, #403f3f 0%, #808080 100%) 0% 0% no-repeat padding-box;
  text-transform: capitalize;
  color: white;
  font-weight: bold;
  font-size: 24px;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  @media (max-width: 600px) {
    width: auto;
  }

  &:disabled {
    background: #b0b0b0;
    color: #f2f2f2;
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
  }
`;

export const CardsWrapper = styled.div`
   input::-webkit-outer-spin-button,
   input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
   }
   flex-direction: row;
   display: flex;
   width: 100%;
   @media screen and (max-width: 850px) {
      flex-direction: column;
      align-items: center;
      img {
      }
      > div:first-child {
         flex-direction: column;
         width: 80%;
         margin-right: 0px;
         align-items: center;
         > div:nth-child(2) {
            width: 100%;
         }
      }
      > div:nth-child(2) {
         width: 80%;
      }
   }
`;

export const Product = styled.div`
   width: 30%;
`;

export const ItemEntry = styled.div`
   display: flex;
   width: 40%;

    .MuiOutlinedInput-root:has(input[name="ndc"][disabled]) {
    background-color: #f5f5f5 !important;
  }
  .MuiOutlinedInput-root:has(input[name="ndc"][disabled]) input {
    color: #999 !important;
  }
`;

export const ImageWrapper = styled.div`
   width: 90%;
   flex-direction: column;
   display: flex;
   align-items: flex-start;
   > img {
      width: 100%;
      height: 100%;
   }
   @media screen and (max-width: 850px) {
      width: 80%;
   }
`;

export const ProductSearchWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;

   .title {
      font: normal normal bold 28px/34px Roboto, Bold;
      color: #a61c14;
      margin-top: 0px;
   }

   .button-group {
      display: flex;
      flex-direction: column;
      gap: 10px;
   }

   .search-button {
      background: #a61c14;
      color: white;
      border: none;
      border-radius: 12px;
      padding: 10px 16px;
      font-weight: bold;
      cursor: pointer;
      transition: background 0.3s ease;

      &:hover {
         background: #881811;
      }
   }
`;

export const ProductSearchAndImageWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   width: 30%;
   gap: 10px;

   @media screen and (max-width: 850px) {
      width: 80%;
      align-items: center;
   }
`;
